// api/services/dashboardOverview.ts
import { handleRequest } from '@/api';
import { formatDateForApi } from '@/utils';

export const getSummary = (start_date: Date | string, end_date: Date | string): Promise<unknown> => {
    const start = formatDateForApi(start_date);
    const end = formatDateForApi(end_date);
    return handleRequest('get', '/dashboard/summary', { start_date: start, end_date: end });
};
